import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { listCitiesOptions } from '../../../features/cities/queries';
import { useAdminPlaceCategories } from '../../../features/places/api/place-categories.queries';
import { placeByIdOptions } from '../../../features/places/api/places.queries';
import { PlaceForm } from '../../../features/places/components/place-form';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/places/$placeId')({
  staticData: { breadcrumb: 'Место' },
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(placeByIdOptions(params.placeId)),
      context.queryClient.ensureQueryData(listCitiesOptions()),
    ]),
  component: EditPlacePage,
});

function EditPlacePage() {
  const { placeId } = Route.useParams();
  const { data: place } = useSuspenseQuery(placeByIdOptions(placeId));
  const { data: cities } = useSuspenseQuery(listCitiesOptions());
  const cats = useAdminPlaceCategories();

  return (
    <div className="space-y-6">
      <PageHeader title={place.name} description={`slug: ${place.slug}`} />
      <PlaceForm mode="edit" place={place} cities={cities} categories={cats.data ?? []} />
    </div>
  );
}
